export const fieldsLabels = {
  vehicleId: "ID do Veículo",
  vehicleChassis: "Chassi",
  vehicleModel: "Modelo do Veículo",
  vehicleLicensePlate: "Placa",
  vehicleType: "Tipo de Veículo",
  vehicleName: "Nome do Veículo",
  vehicleYear: "Ano do Veículo",
  vehicleSaleDate: "Data de Venda do Veículo",
  vehicleOdometer: "Odômetro",
  vehicleHourmeter: "Horômetro",
  vehiclePayloadType: "Carga",
  vehicleMaximumPayload: "Peso da carga",
  vehicleCriticalPayload: "Carga Crítica",
  vehicleStopped: "Unidade Parada",

  driverName: "Nome do Motorista",
  driverLicenseNumber: "CNH do Motorista",
  driverPhone: "Telefone do Motorista",
  driverCheckInDriver: "Localização do Motorista",

  dealershipName: "Nome da Concessionária",
  dealershipDn: "DN da Concessionária",
  dealershipUniqueId: "CNPJ da Concessionária",
  dealershipLocation: "Localização da Concessionária",
  dealershipRepresentative: "Representante da Concessionária",
  dealershipRegional: "Regional da Concessionária",
  dealershipPhone: "Telefone da Concessionária",
  dealershipDemarcatedArea: "Área Demarcada da Concessionária",

  partOrders: "Pedidos de Peças",
  partOrderParts: "Peças",
  partOrder: "Pedido de Peças",
  partOrderDtOrder: "Data do Pedido de Peças",
  partOrderDtEstimate: "Data da Previsão de Entrega",
  partOrderDtDeliveryEstimate: "Data de Entrega da Peça",
  partOrderStatus: "Status Peças",
  partOrderNumber: "Número do Pedido de Peças",
  partOrderStatusOrder: "Status do Pedido de Peças",
  partOrderDeliveryDates: "Datas de Entrega do Pedido de Peças",

  criticality: "Criticidade",
  osNumber: "Número da OS",
  osDtOpenAt: "Data de Abertura da OS",
  createdBy: "Criado por",
  literatureDiagnosis: "Leitura de Diagnóstico",
  literatureTroubleshooting: "Literatura para Troubleshooting",
  country: "País",
  occurrenceType: "Tipo de Ocorrência",
  tasNumber: "Número TAS",
  tasStatus: "Status TAS",
  timeOpenProtocol: "Tempo para Abertura do Protocolo",
  source: "Origem",
  hasLink: "Possui Vínculo",
  mainOccurrence: "Ocorrência Principal",
  estimateTimeRepair: "Tempo Estimado de Reparo",
  solutionProposed: "Reparo/Solução Dada",
  mechanicLocation: "Localização do Mecânico",
  towTruckLocation: "Localização do Guincho",
  checklist: "Checklist",
  customer: "Cliente",
  renter: "Locatário",
  emissionStandard: "Legislação",
  protocolNumber: "Número do Protocolo",
  scheduleNumber: "UUID do Agendamento",
  failureType: "Tipo de Falha",
};

export const fieldsWorklogLabels = {
  currentStep: "Etapa Atual",
  criticality: "Criticidade",
  osNumber: "Número da OS",
  osDtOpenAt: "Data de Abertura da OS",
  renter: "Locatário",
  literatureTroubleshooting: "Literatura para Troubleshooting",
  occurrenceType: "Tipo de Ocorrência",
  tasNumber: "Número TAS",
  tasStatus: "Status TAS",
  timeOpenProtocol: "Tempo para Abertura do Protocolo",
  source: "Origem",
  hasLink: "Possui Vínculo",
  observation: "Observação",
  status: "Status",
  mainOccurrence: "Ocorrência Principal",
  estimateTimeRepair: "Tempo Estimado de Reparo",
  solutionProposed: "Reparo/Solução Dada",
  mechanicLocation: "Localização do Mecânico",
  towTruckLocation: "Localização do Guincho",
  checklist: "Checklist",
  customer: "Cliente",
  protocolNumber: "Número do Protocolo",
  partnerId: "ID do Parceiro",
  hasCampaigns: "Possui Campanhas",
  finalizationReasonType: "Tipo de Motivo de Finalização",
  finalizationReasonDescription: "Descrição do Motivo de Finalização",

  // Campos do veículo
  vehicleChassis: "Chassi",
  vehicleModel: "Modelo do Veículo",
  vehicleLicensePlate: "Placa",
  vehicleVehicleType: "Tipo de Veículo",
  vehicleName: "Nome do Veículo",
  vehicleVehicleYear: "Ano do Veículo",
  vehicleOdometer: "Odômetro",
  vehicleHourMeter: "Horômetro",
  vehicleEmissionStandard: "Legislação",
  vehiclePayloadType: "Carga",
  vehicleMaximumPayload: "Peso da carga",
  vehicleCriticalPayload: "Carga Crítica",
  vehicleStopped: "Unidade Parada",

  // Campos do motorista
  driverName: "Nome do Motorista",
  driverLicenseNumber: "CNH do Motorista",
  driverPhone: "Telefone do Motorista",
  driverCheckInDriver: "Localização do Motorista",

  // Campos da concessionária
  dealershipDn: "DN da Concessionária",
  dealershipRegional: "Regional da Concessionária",
  dealershipLocal: "Local da Concessionária",
  dealershipRepresentative: "Representante da Concessionária",
  dealershipCellNumber: "Telefone da Concessionária",
  dealershipArea: "Área da Concessionária",

  // Campos legados (mantidos para compatibilidade)
  vehicleId: "ID do Veículo",
  vehicleType: "Tipo de Veículo",
  vehicleYear: "Ano do Veículo",
  vehicleSaleDate: "Data de Venda do Veículo",
  vehicleHourmeter: "Horômetro",

  dealershipName: "Nome da Concessionária",
  dealershipUniqueId: "CNPJ da Concessionária",
  dealershipLocation: "Localização da Concessionária",
  dealershipPhone: "Telefone da Concessionária",
  dealershipDemarcatedArea: "Área Demarcada da Concessionária",

  partOrders: "Pedidos de Peças",
  partOrderParts: "Peças",
  partOrder: "Pedido de Peças",
  partOrderDtOrder: "Data do Pedido de Peças",
  partOrderDtEstimate: "Data da Previsão de Entrega",
  partOrderDtDeliveryEstimate: "Data de Entrega da Peça",
  partOrderStatus: "Status Peças",
  partOrderNumber: "Número do Pedido de Peças",
  partOrderStatusOrder: "Status do Pedido de Peças",
  partOrderDeliveryDates: "Datas de Entrega do Pedido de Peças",

  createdBy: "Criado por",
  literatureDiagnosis: "Leitura de Diagnóstico",
  country: "País",
  emissionStandard: "Legislação",
  scheduleNumber: "UUID do Agendamento",
  failureType: "Tipo de Falha",
  failures: "Falhas",
  comment: "Comentário",

  // Campos de acionamento
  dispatchStatus: "Status do Acionamento",
};
